import { HotelGuestReviewAuthor } from './hotelGuestReviewAuthor';
import { HotelGuestReviewContent } from './hotelGuestReviewContent';

export interface HotelGuestReview {
  data: Array<{
    author: HotelGuestReviewAuthor;
    contents?: Array<HotelGuestReviewContent>;
    postedAt: string;
    providerCode: string;
    rating: number;
    reviewUrl: string;
    title?: string;
  }>;
  meta: {
    hightlights: Array<string>;
    pagination: {
      currentPage: number;
      prevPage?: number;
      nextPage?: number;
      totalCount: number;
      totalPages: number;
    };
    synonymsMap: {
      [key: string]: string[];
    };
  };
}

export enum REVIEW_SORT_BY {
  most_recent = 'posted_at,desc',
  highest_score = 'rating,desc',
  lowest_score = 'rating,asc',
}

export enum REVIEW_GUEST_TYPE {
  all_guests = '',
  extended_group = 'extended_group',
  couples = 'couple',
  family_with_children = 'family_with_children',
  solo = 'solo_traveller',
}
